import React from "react";
import { FormattedMessage } from "react-intl";

import { Login } from "@auth/components/Login";
import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { LanguageSelect } from "@localisation/components/LanguageSelect";

function LoginPage(): JSX.Element {
    return (
        <div className="login-page">
            <div className="m-auto">
                <LanguageSelect />
                <h2 className="display-1">
                    <FormattedMessage id="pages.login.title" defaultMessage="Sign in" />
                </h2>
                <p>
                    <FormattedMessage id="pages.login.intro"
                        defaultMessage="You need to log in to access Watamusic." />
                </p>
                <Login />
            </div>
        </div>
    );
}

const LoginPageSetTitle = setTitleOnPage(messages.pageLoginTitle)(LoginPage);

export { LoginPageSetTitle as LoginPage };
